/* WaniTas contactpagina — formulierlogica en botfilter.
 *
 * Lagen tegen bots (naast Shopify's eigen hCaptcha, die op de server controleert):
 *  1. Verborgen verzendadres: in de HTML staat geen bruikbaar formulieradres.
 *     Pas bij de eerste echte interactie (muis, toets, aanraking) zet dit script
 *     het juiste adres terug. Bots die alleen de HTML lezen posten dus in het niets.
 *  2. Honeypot: een onzichtbaar veld dat mensen nooit invullen. Gevuld = bot.
 *  3. Tijdscheck: wie binnen een paar seconden na het laden al verstuurt, is geen mens.
 *  4. Interactiecheck: zonder ooit een toets of muis/aanraking te gebruiken
 *     kan een mens het formulier niet invullen.
 * Een bot die tegen 2–4 aanloopt krijgt een nep-"gelukt"-melding en er wordt
 * niets verstuurd — zo leert hij ook niet dat hij geblokkeerd is.
 *
 * Je e-mailadres staat nergens in de pagina: Shopify stuurt het bericht op de
 * server door naar het adres uit je winkelinstellingen.
 */
(function () {
  'use strict';

  function norm(s) { return String(s || '').trim().toLowerCase(); }

  function init(root) {
    if (root.dataset.wtcReady) return;
    root.dataset.wtcReady = '1';

    var success = root.querySelector('[data-wtc-success]');
    if (success) {
      // Na een geslaagde verzending: melding in beeld en focus erop (ook voor schermlezers)
      requestAnimationFrame(function () {
        success.scrollIntoView({ behavior: 'smooth', block: 'center' });
        success.focus({ preventScroll: true });
      });
      return;
    }

    var form = root.querySelector('form');
    if (!form) return;

    var cfg = root.dataset;
    var minMs = (parseFloat(cfg.wtcMinSeconds) || 3) * 1000;
    var loadedAt = Date.now();
    var human = false;
    var fakeBox = root.querySelector('[data-wtc-fake]');
    var btn = form.querySelector('[data-wtc-submit]');
    var noJs = root.querySelector('[data-wtc-nojs]');
    if (noJs) noJs.remove();
    if (btn) btn.disabled = false;

    // ---- 1. Verzendadres pas zetten bij echte interactie ----
    function markHuman() {
      if (human) return;
      human = true;
      var real = form.getAttribute('data-wtc-a');
      if (real) form.setAttribute('action', real);
    }
    ['pointerdown', 'keydown', 'touchstart'].forEach(function (ev) {
      form.addEventListener(ev, markHuman, { passive: true });
    });

    // ---- Velden die alleen bij een bepaald onderwerp verschijnen ----
    var topic = form.querySelector('[data-wtc-topic]');
    var conditionals = form.querySelectorAll('[data-wtc-show-when]');
    function applyConditions(animate) {
      var val = topic ? norm(topic.value) : '';
      conditionals.forEach(function (wrap) {
        var wanted = wrap.getAttribute('data-wtc-show-when').split(',').map(norm).filter(Boolean);
        var show = wanted.indexOf(val) !== -1;
        var wasHidden = wrap.hidden;
        wrap.hidden = !show;
        wrap.querySelectorAll('input,select,textarea').forEach(function (el) { el.disabled = !show; });
        if (show && wasHidden && animate) {
          wrap.classList.remove('is-opening'); void wrap.offsetWidth; wrap.classList.add('is-opening');
        }
      });
    }
    if (topic) topic.addEventListener('change', function () { applyConditions(true); });
    applyConditions(false);

    // ---- Nette foutmeldingen in de huisstijl i.p.v. de browserballonnetjes ----
    form.setAttribute('novalidate', '');
    function fieldError(el) {
      if (el.disabled) return '';
      var v = el.validity;
      if (v.valueMissing) return el.type === 'checkbox' ? (el.dataset.wtcMsg || cfg.wtcMsgCheck) : cfg.wtcMsgRequired;
      if (v.typeMismatch && el.type === 'email') return cfg.wtcMsgEmail;
      if (!v.valid) return cfg.wtcMsgRequired;
      return '';
    }
    function showError(el, msg) {
      var wrap = el.closest('.wtc-field');
      if (!wrap) return;
      var out = wrap.querySelector('.wtc-err');
      wrap.classList.toggle('has-error', !!msg);
      el.setAttribute('aria-invalid', msg ? 'true' : 'false');
      if (out) out.textContent = msg || '';
    }
    form.querySelectorAll('.wtc-field input, .wtc-field select, .wtc-field textarea').forEach(function (el) {
      var evt = (el.type === 'checkbox' || el.tagName === 'SELECT') ? 'change' : 'blur';
      el.addEventListener(evt, function () { if (el.closest('.has-error') || el.value) showError(el, fieldError(el)); });
      el.addEventListener('input', function () { if (el.closest('.has-error')) showError(el, fieldError(el)); });
    });

    // ---- Verzenden ----
    form.addEventListener('submit', function (e) {
      // Eerst gewone validatie, zodat een mens met een leeg veld nooit een nep-melding krijgt
      var first = null;
      form.querySelectorAll('.wtc-field input, .wtc-field select, .wtc-field textarea').forEach(function (el) {
        var msg = fieldError(el);
        showError(el, msg);
        if (msg && !first) first = el;
      });
      if (first) {
        e.preventDefault();
        first.focus();
        return;
      }

      // 2–4: botcontrole
      var hp = form.querySelector('[data-wtc-hp]');
      var tooFast = Date.now() - loadedAt < minMs;
      if ((hp && hp.value !== '') || tooFast || !human) {
        e.preventDefault();
        if (fakeBox) { form.hidden = true; fakeBox.hidden = false; }
        return;
      }

      // Zorg dat het echte adres zeker gezet is en voorkom dubbel klikken
      var real = form.getAttribute('data-wtc-a');
      if (real) form.setAttribute('action', real);
      if (btn) {
        btn.setAttribute('aria-busy', 'true');
        if (btn.dataset.wtcSending) btn.querySelector('span').textContent = btn.dataset.wtcSending;
        setTimeout(function () { btn.disabled = true; }, 0);
      }
    });
  }

  function boot() { document.querySelectorAll('[data-wtc-root]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  // Opnieuw starten als de sectie in de theme-editor wordt herladen
  document.addEventListener('shopify:section:load', boot);
})();
